<template>
    <div class="annt-privacy-wrapper">
        <el-dropdown @command="handlerSelete" class="lang-seletor" trigger="click">
            <el-button
                type="text"
                icon="icon iconfont icon-button icon-yinsixieyiicon">隐私协议</el-button>
            <template  #dropdown>
                <el-dropdown-menu class="privacy-dropdown">
                    <el-dropdown-item command="legal">隐私声明</el-dropdown-item>
                    <el-dropdown-item command="about">联系我们</el-dropdown-item>
                    <el-dropdown-item command="terms">服务条款</el-dropdown-item>
                </el-dropdown-menu>
            </template>
        </el-dropdown>
    </div>
</template>

<script>
export default {
    name: 'AnntPrivacy',
    methods: {
        handlerSelete (command) {
            if (command === 'legal') {
                window.open('https://static.annto.com/res/webInfo/privacy.html');
            } else if (command === 'about') {
                window.open('https://static.annto.com/res/webInfo/contact_us.html');
            } else if (command === 'terms') {
                window.open('https://static.annto.com/res/webInfo/service.html');
            }
        }
    }
};
</script>

<style lang="less">
.annt-privacy-wrapper {
    .icon-button {
        font-size: 14px;
    }
}
.privacy-dropdown {
    padding: 8px 0;
    li {
        padding: 4px 16px;
    }
}
</style>
